import React from 'react';
import { useTranslation } from 'react-i18next';
import LegacyAccountPage from '@/components/domain/auth/LegacyAccountPage';
import { communities, isCommunityCode, type CommunityCode } from '@/constants/communities';
import { useLocalSearchParams } from 'expo-router';

export default function CommunitiesForgotPassword() {
  const { t } = useTranslation();
  const { community } = useLocalSearchParams<{ community?: CommunityCode }>();
  const communityCode = isCommunityCode(community) ? community : undefined;

  const helper = communityCode
    ? t('auth.forgotPassword.redirectHelper', { communityName: communities[communityCode].name })
    : t('auth.forgotPassword.redirectHelper', { communityName: '' });

  return (
    <LegacyAccountPage
      accountPath={'/Account/LostPassword'}
      titleText={t('auth.forgotPassword.title')}
      webHelperText={helper}
      successText={t('auth.forgotPassword.successToast')}
    />
  );
}


